var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12 1.20312 12.6562 0.5 13.5 0.5H19.4531C19.6875 0.5 19.875 0.546875 20.0625 0.640625C20.2031 0.6875 20.3906 0.828125 20.5312 0.96875C20.8125 1.25 20.9531 1.625 21 2V8C21 8.84375 20.2969 9.5 19.5 9.5C18.6562 9.5 18 8.84375 18 8V5.65625L10.0312 13.5781C9.46875 14.1875 8.48438 14.1875 7.92188 13.5781C7.3125 13.0156 7.3125 12.0312 7.92188 11.4688L15.8438 3.5H13.5C12.6562 3.5 12 2.84375 12 2ZM0 5C0 3.35938 1.3125 2 3 2H7.5C8.29688 2 9 2.70312 9 3.5C9 4.34375 8.29688 5 7.5 5H3V18.5H16.5V14C16.5 13.2031 17.1562 12.5 18 12.5C18.7969 12.5 19.5 13.2031 19.5 14V18.5C19.5 20.1875 18.1406 21.5 16.5 21.5H3C1.3125 21.5 0 20.1875 0 18.5V5Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPage);
export default __webpack_public_path__ + "static/media/webPage.cdac489ae7b01c8f8f7521017f3fa5e5.svg";
export { ForwardRef as ReactComponent };